import ConfirmSetChildPasscode from "./ConfirmSetChildPasscode"
import DeleteChildPasscode from "./DeleteChildPasscode"
import SetChildPasscode from "./SetChildPasscode"
import { useChildPasscodeModalStore } from "./useChildPasscodeModalStore"
import { CloseButton } from "../../../../components/closeButton/CloseButton"
import TransitionWrapper from "../../../../components/coaching/TransitionWrapper"
import SlideUpModal from "../../../../components/slideUpModal/SlideUpModal"
import { ChildPasscodeStep } from "../../../../types"

const ChildPasscodeModal = () => {
  const { isOpen, onClose, step } = useChildPasscodeModalStore()

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      size="fit-content"
      backgroundType="overlay"
      zIndex={1000}
    >
      <div className="w-full p-4 pt-6">
        <CloseButton onClick={onClose} />
        <TransitionWrapper
          showChildren={step === ChildPasscodeStep.SET_PASSCODE}
        >
          <SetChildPasscode />
        </TransitionWrapper>
        <TransitionWrapper
          showChildren={step === ChildPasscodeStep.CONFIRM_SET_PASSCODE}
        >
          <ConfirmSetChildPasscode />
        </TransitionWrapper>
        <TransitionWrapper
          showChildren={step === ChildPasscodeStep.DELETE_PASSCODE}
        >
          <DeleteChildPasscode />
        </TransitionWrapper>
      </div>
    </SlideUpModal>
  )
}

export default ChildPasscodeModal
